import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, PopoverModule, SplitViewModule } from '@spartacus/storefront';
import { MessageModule } from '@spartacus/organization/administration/components';
import { UigCardComponent } from './uig-card/uig-card.component';

@NgModule({
  imports: [
    CommonModule,
    SplitViewModule,
    RouterModule,
    I18nModule,
    IconModule,
    UrlModule,
    MessageModule,
    PopoverModule,
  ],
  declarations: [UigCardComponent],
  exports: [UigCardComponent],
})
export class UigCardModule { }
